import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from '../../stores';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import { Grid, Typography } from '@mui/material';
import { PageWrapper, Input, Button } from '../../components';
import { DirectionsCar, Search } from '@mui/icons-material';

import { fetchVehicleConsult, clearVehicleConsult } from '../../stores';

import { palette, theme } from '../../theme';

import useResponsiveMode from '../../utils/useResponsiveMode';

export const VehicleConsult: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const responsiveMode = useResponsiveMode();

  const { profileId } = useSelector((state) => state.authReducer);

  const {
    isVehicleConsultLoading,
    vehicleConsultList,
    error,
    consultDateTime
  } = useSelector(state => state.vehicleConsultReducer);

  const [plate, setPlate] = useState('');

  useEffect(() => {
    if (+profileId != 10) {
      navigate('/');
    }
  }, [profileId]);

  useEffect(() => {
    dispatch(clearVehicleConsult());
  }, []);

  const handleVehicleConsult = () => {
    if (!plate) {
      return;
    }

    dispatch(fetchVehicleConsult(plate));
  }

  return (
    <PageWrapper>
      <Grid container padding={1}>
        <Grid item lg={12} md={12} sm={12} xs={12} margin={1}>
          <Typography
            variant={responsiveMode != 'phone' ? 'h4' : 'h5'}
            margin={1}
            display='flex'
            justifyContent='flex-start'
            alignItems='center'
            color={palette.text.main}
          >
            <DirectionsCar fontSize='large' sx={{ marginRight: 2 }} />
            Consulta de Veículo
          </Typography>
        </Grid>
        <Grid item lg={9} md={9} sm={9} xs={12}>
          <Input
            data-testid='name'
            type='text'
            margin='normal'
            label='Placa'
            value={plate}
            onChange={(value) => {
              if (value.length == 8) {
                return;
              }

              setPlate(value.replace(/[^a-z0-9]/gi, "").toUpperCase());
            }}
          />
        </Grid>
        <Grid container lg={3} md={3} sm={3} xs={12} alignItems='center'>
          <Button
            fullWidth
            loading={isVehicleConsultLoading}
            variant='contained'
            label='Consultar'
            startIcon={<Search />}
            onClick={handleVehicleConsult}
          />
        </Grid>
        <Grid container spacing={1}>
          {vehicleConsultList.length > 0 && vehicleConsultList.map(vehicle => {
            return (
              <Grid item lg={4} md={6} xs={12}>
                <Grid container direction='column' style={{ backgroundColor: '#FFFFFF', border: `solid 3px ${theme.palette.success.main}`, borderRadius: 8, padding: 10 }}>
                  <Typography>
                    Veículo Regular
                  </Typography>
                  <Typography>
                    Placa: {vehicle.PLACA}
                  </Typography>
                  <Typography>
                    Hora final: {moment(vehicle.HORA_FINAL, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')}
                  </Typography>
                  <Typography>
                    Horário da consulta: {moment(moment.now()).format('DD/MM/YYYY HH:mm:ss')}
                  </Typography>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
        {error && (
          <Grid item xs={12}>
            <Grid container direction='column' style={{ width: 'fit-content', backgroundColor: '#FFFFFF', border: `solid 3px ${theme.palette.error.main}`, borderRadius: 8, padding: 10 }}>
              <Typography>Sem ticket válido no momento.</Typography>
              <Typography>Horário da consulta: {consultDateTime}</Typography>
            </Grid>
          </Grid>
        )}
      </Grid>
    </PageWrapper>
  );
}